import * as R from 'ramda'
import Moment from 'moment'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { db, doc, props, makePropSelector } from './common'
import { properties, managers, tenants, tasks, leases, projects } from './entities'
import { projectsByPropertyID } from './index'

var data = state => state.data.db
var attachments = state => state.attachments

let tasksWithDeps = (tasks) => (taskID) => ({
	...tasks[taskID]
	, time: (tasks[taskID] && tasks[taskID].schedule)? Moment(tasks[taskID].schedule.curDue).format("MM/DD/YY") : ''
    , overdue: (tasks[taskID] && tasks[taskID].schedule)? Moment() > Moment(tasks[taskID].schedule.curDue): false
	, doneTime: (tasks[taskID] && tasks[taskID].doneTime)? Moment(tasks[taskID].doneTime).format("MM/DD/YY") : undefined
	, dependsOnEnded:
			(tasks[taskID] && tasks[taskID].dependencies)?
					R.all(
							(taskid) =>
									(tasks[taskid])?
											tasks[taskid].done
											: true
					)
					(tasks[taskID].dependencies)
			: true
})

export default (state) => (id) => {
	let project = projects(state)[id]
	if(!project) return undefined
	return({
		...project
	  , owner: managers[project.managerID]
	  , property: (project.isForAll)? "All" : properties(state)[project.propertyID]
	  , tasks: (project.tasks)? R.reject((task) => !task, R.map((val) => tasksWithDeps(tasks(state))(val), project.tasks)):[]
	  , tenant:
		(project.isForAll)? "All" :
			(project.tenantID && project.tenantID.length)?
				tenants(state)[project.tenantID]
					: (properties(state)[project.propertyID] && properties(state)[project.propertyID].leaseID && properties(state)[project.propertyID].leaseID.length && leases(state)[properties(state)[project.propertyID].leaseID])?
						tenants(state)[leases(state)[properties(state)[project.propertyID].leaseID].tenantsIDs[0]]
							: ''
			  , comments: (project.comments)?R.map(
					commentData =>({
						...commentData
					  , attachments: (commentData.attachmentsIDs)?
							R.map(
								attachmentID =>
									(attachments[project._id]
									&& attachments[project._id].attachments
									&& attachments[project._id].attachments[attachmentID.id]
									)?
										attachments[project._id].attachments[attachmentID.id]
										: false
								, commentData.attachmentsIDs
							)
							: {}
					})
					, project.comments)
					: []
	})
}

let empty = []
export let propertyProjects = createSelector(
	[projectsByPropertyID, props]
  , (projectsByPropertyID, propertyID) => (
		projectsByPropertyID[propertyID] || empty
	)
)

export let propertyOpenProjects = createSelector(
	propertyProjects
  , R.filter(x => x.status.toLowerCase() == 'open')
)

export let projectProperty = createSelector(
	[doc, props]
  , (project, projectID) => {
  		return doc[project.propertyID]
  	}
)

export let projectTasks = createSelector([tasks, makePropSelector('objectID')], (tasks, pojectID) => R.values(R.filter(x => x.projectID == pojectID, tasks)))



// WEBPACK FOOTER //
// ./src/selectors/project.js